import { render, staticRenderFns } from "./ModuleCard.vue?vue&type=template&id=51e8f024&scoped=true"
import script from "./ModuleCard.vue?vue&type=script&lang=js"
export * from "./ModuleCard.vue?vue&type=script&lang=js"
import style0 from "./ModuleCard.vue?vue&type=style&index=0&id=51e8f024&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8f024",
  null
  
)

export default component.exports